import React from 'react';
import { createDataSource, createGridOptions, DataGrid, indexCellRenderer, LinkCellRenderer, TextFilterDefaults } from '../common/dataGrid/DataGrid';
import DataGridSelectFilter from '../common/dataGrid/DataGridSelectFilter';
import CommonContext, { agGridConstants, ApiRoutes, AppNavPaths } from '../Common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarehouse } from '@fortawesome/free-solid-svg-icons'
import { LinearProgress } from '@material-ui/core';
import { PageHeading, PageWrap, SmallOutlineButton } from '../common/forms/FormElements';
import { util } from '../Util';
import { withRouter } from "react-router-dom";
import DataGridSelectFloatingFilter from '../common/dataGrid/DataGridSelectFloatingFilter';
import DataGridToolbar from '../common/dataGrid/DataGridToolbar';
import { Can } from '../Can';

class GroupIndex extends React.Component {

    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        }
    }

    componentDidMount = () => this.populateState();
    componentWillUnmount = () => this.setState = (state, callback) => { return };
    onViewGroup = (id) => this.props.history.push(`${AppNavPaths.Group}/${id}`);

    populateState = async () => {

        var [roles] = await Promise.all([            
            util.fetch.js(ApiRoutes.typeAheads.roles())
        ]);

        let gridOptions = createGridOptions(this);

        gridOptions.components = {
            selectFilter: DataGridSelectFilter,
            selectFloatingFilter: DataGridSelectFloatingFilter,
            nameRenderer: LinkCellRenderer
        };

        gridOptions.columnDefs = [
            {
                flex: 0,
                width: 70,
                minWidth: 70,
                maxWidth: 70,
                headerName: "",
                valueGetter: "node.id",
                sortable: false,
                cellRenderer: indexCellRenderer
            },
            {
                colId: 'GroupName',
                sortable: true,
                headerName: 'Group Name',
                field: 'groupName',
                flex: 0,
                width: 300,
                minWidth: 300,
                maxWidth: 300,
                filter: agGridConstants.columnFilterTypes.text,
                floatingFilter: true,
                filterParams: TextFilterDefaults,   
                sort: { direction: 'asc', priority: 0 },
                cellRenderer: 'nameRenderer',
                cellRendererParams: {
                    clicked: this.onViewGroup,
                    nameField: 'groupName',
                    idField: 'id',
                    title: 'View this Group'
                }
            },
            {
                colId: 'ApplicationUserGroupRoles.ApplicationRoleId',
                sortable: false,
                headerName: 'Roles',
                field: 'rolesFlat',
                filter: 'selectFilter',
                floatingFilter: true,
                filterParams: {
                    labelText: 'Filter by type',
                    options: roles,
                    optionsLabel: 'label',
                    optionsValue: 'value',
                },
                floatingFilterComponent: 'selectFloatingFilter',
                floatingFilterComponentParams: {
                    suppressFilterButton: true,
                    options: roles,
                    optionsLabel: 'label',
                    optionsValue: 'value'
                },
                tooltipField: 'rolesFlat'
            },
            {
                colId: 'Code',
                sortable: false,
                headerName: 'Code',
                flex: 0,
                width: 140,
                minWidth: 140,
                maxWidth: 140,
                field: 'code',
                filter: agGridConstants.columnFilterTypes.text,
                floatingFilter: true,
                filterParams: TextFilterDefaults,   
            },
            {
                sortable: false,
                headerName: 'Require MFA?',
                field: 'requireMFA',
                flex: 0,
                width: 140,
                minWidth: 140,
                maxWidth: 140,
                cellRenderer: (params) => {
                    if (params.value === undefined)
                        return '';

                    return !!params?.value ? 'Yes' : 'No';
                }
            }
        ];

        let ds = createDataSource(ApiRoutes.group.search(), gridOptions);

        this.setState({
            loading: false,
            gridOptions: gridOptions,
            dataSource: ds
        });
    }

    render() {
        if (!!this.state.loading) return (<LinearProgress variant="indeterminate" color="secondary" />)
        let { rowData, gridOptions } = this.state;

        return (
            <PageWrap>
                <PageHeading>
                    <FontAwesomeIcon icon={faWarehouse} className="mr-2 text-muted" />
                    <span>Groups</span>
                    <Can I="create" a={"group"}>
                        <SmallOutlineButton type="button" onClick={() => this.props.history.push(`${AppNavPaths.GroupNew}`)} className="float-right">
                            <i className={`fa fa-md mr-2 fa-plus-square`} />
                            Add Group
                        </SmallOutlineButton>
                    </Can>
                </PageHeading>
                <DataGridToolbar
                    entity="group"
                    gridApi={this.state.gridApi}
                    dataSource={this.state.dataSource}
                    hideAdd={true}
                />
                <DataGrid
                    domLayout={"normal"}
                    rowData={rowData}
                    gridOptions={gridOptions}
                    gridStatus={this.state.gridStatus}
                >
                </DataGrid>
            </PageWrap>
        );
    }
}
export default withRouter(GroupIndex);